import { START, SUCCESS, ERROR } from '../../constants/action-postfix'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { reportsAPI } from '../../api/reports'
import { stopSubmit } from 'redux-form'
import { createActions } from '../factory/actionFactory'
import { MAX_RETRIES } from '../../constants/api'

export const ORGANIZATION_LIST_REQUEST = 'ORGANIZATION_LIST_REQUEST'
export const SET_ORG_CERT_REQUEST = 'SET_ORG_CERT_REQUEST'

const initialState = {
  data: [],
  isLoading: false,
  error: null,
}

export const organizationListReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${ORGANIZATION_LIST_REQUEST}${START}`:
      return {
        data: [],
        isLoading: true,
        error: null,
      }
    case `${ORGANIZATION_LIST_REQUEST}${SUCCESS}`:
      return {
        data: action.payload,
        isLoading: false,
        error: null,
      }

    case `${ORGANIZATION_LIST_REQUEST}${ERROR}`:
      return {
        data: null,
        isLoading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

// ACTIONS

export const organizationList = createActions('organizationList', ORGANIZATION_LIST_REQUEST)
export const setOrgCertification = createActions('setOrgCertification', SET_ORG_CERT_REQUEST)

// SAGAS

export function* organizationListWatcher() {
  yield takeEvery(`${ORGANIZATION_LIST_REQUEST}${START}`, organizationListWorker)
  yield takeEvery(`${SET_ORG_CERT_REQUEST}${START}`, setDigCertificationWorker)
}

function* organizationListWorker({ payload }) {
  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      const res = yield call(reportsAPI.organizationList, payload)
      const { Result, Data } = res.data.Answer
      if (Result === 'Error') continue
      yield put(organizationList.organizationListRequestSuccess(Data || []))
      return
    } catch (error) {
      if (attempt === MAX_RETRIES) {
        yield put(organizationList.organizationListRequestError(error.response.data))
        const message = error.response.data.Answer.Message || 'Возникла непредвиденная ошибка'
        yield put(stopSubmit('orglist', { _error: message }))
      }
    }
  }
}

function* setDigCertificationWorker ({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...auth, ...payload}
    yield call(reportsAPI.setOrganizationCerification, params)
    yield put(organizationList.organizationListRequestStart(auth))
  } catch (error) {
    yield put(setOrgCertification.setOrgCertificationRequestError(error.response.data))
  }
}

export const getOrgList = state => state.reports.orgList.data
